module.exports = __webpack_public_path__ + "static/media/basic.92e5eab9.jpg";